module.exports = __webpack_public_path__ + "img/20190618161907188.6fda3d44.png";